import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=9f1bf9a4&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1bf9a4",
  null
  
)

export default component.exports